module.exports = __webpack_public_path__ + "img/c422518.webp";